import React from "react";
import { Table, Divider, Popconfirm, Button, Typography } from "antd";
import { withRouter } from "react-router-dom";
import moment from 'moment'
const { Text } = Typography;
const HSNTable = ({
  pagination,
  dataSource,
  openModal,
  spinner,
  delete: deleteData,
  history,
  modify,
  deleteAccess,
}) => {
  const { goBack } = history;

  const column = [
    // {
    //   render: () => (
    //     <Button
    //       type="ghost"
    //       size="small"
    //       shape="circle"
    //       onClick={(event) => {
    //         event.stopPropagation();
    //         goBack();
    //       }}
    //     >
    //       ...
    //     </Button>
    //   ),
    // },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (record) => (record && <span>{record}</span>) || "NA",
    },
    {
      title: "CGST",
      dataIndex: "cgst",
      key: "cgst",
      render: (record) => (record && <span>{record}%</span>) || "-",
    },
    {
      title: "SGST",
      dataIndex: "sgst",
      key: "sgst",
      render: (record) => (record && <span>{record}%</span>) || "-",
    },
    {
      title: "IGST",
      dataIndex: "igst",
      key: "igst",
      render: (record) => (record && <span>{record}%</span>) || "-",
    },
    {
      title: "Cess",
      dataIndex: "cess",
      key: "cess",
      render: (record) => <span>{(record && record + "%") || "-"}</span>,
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "createdOn",
      render: (record) => <span>{moment(new Date(record)).format('DD/MM/YYYY')}</span>,
    },
    {
      title: "Action",
      render: (record) => (
        <div>
          {modify ? (
            <span
              onClick={(event) => {
                event.stopPropagation();
                openModal(record.id, true);
              }}
              className="linkylink"
            >
              Modify
            </span>
          ) : (
            <span></span>
          )}
          {deleteAccess ? (
            <Popconfirm
              title="Do you want to delete this HSN Code?"
              okText="Yes"
              cancelText="No"
              onCancel={(event) => {
                event.stopPropagation();
              }}
              onConfirm={(event) => {
                event.stopPropagation();
                deleteData(record.id);
              }}
            >
              <span
                className="linkylink"
                onClick={(event) => event.stopPropagation()}
              >
                <Divider type="vertical" />
                Delete
              </span>
            </Popconfirm>
          ) : (
            <span></span>
          )}
          {!modify && !deleteAccess ? (
            <Text strong disabled>
              No Actions Given
            </Text>
          ) : (
            <span></span>
          )}

          {/* <Divider type="vertical" />
          <Button type="ghost" size="small" shape="circle">
            ...
          </Button> */}
        </div>
      ),
    },
  ];

  return (
    <Table
      rowKey={(props) => props.id}
      pagination={pagination}
      columns={column}
      dataSource={dataSource}
      style={{ cursor: "pointer" }}
      onRow={(record) => ({
        onClick: () => {
          openModal(record.id, false);
        },
      })}
      loading={spinner}
    />
  );
};

export default withRouter(HSNTable);
